/* Video hero
   - Honours prefers-reduced-motion by not autoplaying.
   - Gives the background video a working pause/play control (WCAG 2.2.2).
   - Defers the YouTube/Vimeo iframe until the play button is pressed, so the
     embed costs nothing on first paint. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setupBackgroundVideo(section) {
    var video = section.querySelector('.video-hero__video, .video-hero__media video');
    var toggle = section.querySelector('[data-video-toggle]');
    if (!video) return;

    // Autoplay only survives if the element is genuinely muted; the attribute
    // alone is not always enough once the node has been re-parented.
    video.muted = true;

    function paused(isPaused) {
      if (toggle) toggle.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
    }

    if (reduceMotion.matches) {
      video.pause();
      video.removeAttribute('autoplay');
      paused(true);
    } else {
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        // Autoplay can still be refused (data saver, low power mode). Reflect
        // that in the control instead of leaving it claiming to be playing.
        attempt.catch(function () {
          paused(true);
        });
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          paused(false);
        } else {
          video.pause();
          paused(true);
        }
      });
    }

    video.addEventListener('play', function () {
      paused(false);
    });
    video.addEventListener('pause', function () {
      paused(true);
    });
  }

  function embedSrc(rawUrl) {
    // Build an autoplaying embed URL from the watch/share URL Shopify stores.
    var youtube = rawUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{6,})/);
    if (youtube) {
      return 'https://www.youtube.com/embed/' + youtube[1] + '?autoplay=1&rel=0&playsinline=1';
    }
    var vimeo = rawUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeo) {
      return 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
    }
    return null;
  }

  function setupEmbed(host) {
    var button = host.querySelector('.video-hero__play');
    if (!button) return;

    button.addEventListener('click', function () {
      var src = embedSrc(host.dataset.embedUrl || '');
      if (!src) return;

      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'Video');

      host.innerHTML = '';
      host.appendChild(iframe);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.video-hero').forEach(setupBackgroundVideo);
    (root || document).querySelectorAll('video-hero-embed').forEach(setupEmbed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Re-run when a merchant adds or edits the section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
